import { Component, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

type TaxResidency = 'us' | 'non_us';

@Component({
  selector: 'app-tax-documentation-residency-step',
  imports: [TranslatePipe],
  templateUrl: './tax-documentation-residency-step.component.html',
  styleUrl: '../tax-documentation-modal.component.scss'
})
export class TaxDocumentationResidencyStepComponent {
  selectedResidency = input.required<TaxResidency>();
  expandedResidencyInfo = input.required<Record<TaxResidency, boolean>>();

  residencySelected = output<TaxResidency>();
  residencyInfoToggled = output<{ residency: TaxResidency; event?: MouseEvent }>();

  onSelectResidency(residency: TaxResidency): void {
    this.residencySelected.emit(residency);
  }

  onToggleResidencyInfo(residency: TaxResidency, event?: MouseEvent): void {
    this.residencyInfoToggled.emit({ residency, event });
  }

  isResidencySelected(residency: TaxResidency): boolean {
    return this.selectedResidency() === residency;
  }

  isResidencyInfoExpanded(residency: TaxResidency): boolean {
    return this.expandedResidencyInfo()[residency];
  }
}
